import request from '@/utils/request'

// 获取RSA公钥
export function getPublicKeyApi() {
    return request({
        url: `/auth/user/rsa/public-key`,
        method: 'get',
    })
}

// 获取图形验证码
export function getImgCodeApi() {
    return request({
        url: `/auth/user/getCode`,
        method: 'get',
    })
}


// 发送手机验证码短信
export function sendMobileCodeApi(data) {
    return request({
        url: `/auth/experienceUser/sendMobileCode`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent
        },
    })
}

// 登录
export function loginV2BySMSApi(data) {
    return request({
        url: `/auth/experienceUser/loginV2BySMS`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent
        },
    })
}

// 退出登录
export function logoutApi() {
    return request({
        url: `/auth/user/logout`,
        method: 'POST',
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent
        },
    })
}
// 财税实操--列表
export function findCSSCList(data) {
    return request({
        url: `/system/training/getExperienceCourseList`,
        method: 'get',
        params: {}
    })
}